import { Link, makeStyles } from '@fluentui/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ISkipNavigationLinkProps {
    mainContentContainerId: string;
}

const focusableElementsSelector = 'button, [href], input, [tabindex="0"]';

const useStyles = makeStyles({
    visuallyHidden: {
        height: '1px',
        width: '1px',
        clip: 'rect(0 0 0 0)',
        overflow: 'hidden',
        position: 'absolute',
        '&:focus, &:focus-within, &:focus-visible': {
            height: 'auto',
            width: 'auto',
            clip: 'none',
            overflow: 'visible',
            position: 'static',
        },
    },
});

const SkipNavigationLink: React.FC<ISkipNavigationLinkProps> = ({ mainContentContainerId }) => {
    const { t } = useTranslation();
    const { visuallyHidden } = useStyles();

    const focusOnFirstFocusableElementInMainContent = (event: React.MouseEvent) => {
        event.preventDefault();
        const mainContent = document.getElementById(mainContentContainerId);

        if (mainContent) {
            const firstFocusableElement = mainContent.querySelector(focusableElementsSelector);

            if (firstFocusableElement) {
                (firstFocusableElement as HTMLElement).focus();
            }
        }
    };

    return (
        <Link href={`#${mainContentContainerId}`} className={visuallyHidden} onClick={focusOnFirstFocusableElementInMainContent}>
            {t('skipNavigation')}
        </Link>
    );
};

export default SkipNavigationLink;
